import React, { useContext, useEffect, useState } from 'react';
import GeneralContext from '../../GeneralContext';
import ReminderCardStatusView from '../view/ReminderCardStatusView';

const ReminderCardEngine = ({
  actionButtons,
  reminderData,
  update,
  onDisabledClicked,
  title,
  setTitle,
  updateTitle,
  ...props
}) => {
  const { form } = useContext(GeneralContext);

  const [statusesDD, setStatusesDD] = useState([]);

  const [intervalCount, setIntervalCount] = useState(
    reminderData.condition.interval
  );

  useEffect(() => {
    // const isAnonymous = form.sharingType === 'anonymous'; // TODO: handle this, hide invalid options
    let newStatusesDD = [];
    if (form && form.customStatuses && reminderData) {
      newStatusesDD = form.customStatuses.map(s => ({
        text: `Status: ${s.label}`,
        value: s.internalId,
        'data-testid': `status-${s.label}-${reminderData.id}`
      }));
    }
    setStatusesDD(newStatusesDD);
  }, [form]);

  const viewProps = {
    title,
    setTitle,
    updateTitle,
    actionButtons,
    reminderData,
    update,
    onDisabledClicked,
    intervalCount,
    setIntervalCount,
    logicRules: reminderData.condition.logicRules
      ? JSON.parse(reminderData.condition.logicRules)
      : [],
    hideRecurring:
      reminderData &&
      reminderData.recurrence &&
      reminderData.recurrence.recurrenceType === 'time',
    statusesDD,
    ...props
  };

  return <ReminderCardStatusView {...viewProps} />;
};

export default ReminderCardEngine;
